export default function (func, namespace) {
  return function (trigger = _.noop, ...args) {

    trigger(`${namespace}.BEFORE`, ...args);

    return func(trigger, ...args)
      .then(function (res) {
        trigger(`${namespace}.SUCCESS`, res, ...args);
        return res;
      })
      .catch(function (res) {
        trigger(`${namespace}.FAIL`, res, ...args);
        return Promise.reject(res);
      });
  };
}



// WEBPACK FOOTER //
// ./src/transport/utils/with-events-triggering.js